export default __webpack_public_path__ + "static/media/send-outline.bb69ad3a.svg";